import { Background } from '../components/layout/Background';
import logo from '../assets/Logo.png';

export function AuthBackgroundLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-10 items-center justify-center">
      <Background />
      <img src={logo} alt="Logo" className="w-[215px] h-[48px]" />
      <div className="flex flex-col w-[458px] py-[32px] px-[40px] gap-6 rounded-lg bg-white shadow items-center">
        {children}
      </div>
    </div>
  );
}
